<div class="description">
  <span class="semi-bold" *ngIf="data.data"
    >Data:<span>{{ data.data }}</span>
  </span>
  <span class="semi-bold" *ngIf="data.orcamentoId"
    >Orc. Força de Vendas:<span>{{ data.orcamentoId }}</span>
  </span>
  <span class="semi-bold" *ngIf="data.orcamentoFilial || data.orcamentoFilial === 0"
    >Orc. Filial: <span>{{ data.orcamentoFilial }}</span></span
  >
  <span class="semi-bold" *ngIf="data.cliente"
    >Cliente:<span>{{ data.cliente }}</span>
  </span>
  <span class="semi-bold" *ngIf="data.vendedor"
    >Vendedor:<span>{{ data.vendedor }}</span>
  </span>
  <span class="semi-bold" *ngIf="data.total"
    >Total:<span class="semi-bold">{{ data.total }}</span>
  </span>
</div>
<div class="actions">
  <button primary-button="primary" [class]="data.status">{{ data.status }}</button>

  <div class="actions-group">
    <div class="action-icon" style="margin-left: 5px" *ngIf="data.hasView" (click)="eventAction.emit(data)">
      <mat-icon> visibility </mat-icon>
      Ver
    </div>
    <div class="action-icon" *ngIf="data.hasEdit" (click)="eventAction.emit(data)">
      <mat-icon> edit </mat-icon>
      Editar
    </div>
    <div class="action-icon" *ngIf="data.hasClose" (click)="eventAction.emit(data)">
      <mat-icon> close </mat-icon>
      Excluir
    </div>
  </div>
</div>
